import { Box } from '@mui/material';
import PaymentsFilters from './components/PaymentsFilters';
import PaymentsDataTable from './components/PaymentsDataTable';
import PaymentsPagination from './components/PaymentsPagination';
import PaymentsDetailsDialog from './components/PaymentsDetailsDialog';
import { useViewPaymentsTable } from './hooks/useViewPaymentsTable';
import { TableTitleBox } from '../../common/components';

/**
 * Componente principal de la vista de pagos agrupados
 */
const ViewPaymentsTable = () => {
  const {
    filters,
    setFilters,
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleExportInvoices,
    openDetails,
    handleOpenDetails,
    handleCloseDetails,
    detailsData,
    dialogInfo,
    theme,
    isExporting,
  } = useViewPaymentsTable();

  return (
    <Box>
      <TableTitleBox title="Habitar 99 | Registrar | Ver cobros" />
      <PaymentsFilters
        filters={filters}
        setFilters={setFilters}
        handleFilter={handleFilter}
        onExport={handleExportInvoices}
        isExporting={isExporting}
      />
      <PaymentsDataTable
        data={data}
        isLoading={isLoading}
        onViewDetails={handleOpenDetails}
      />
      <PaymentsPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        theme={theme}
      />
      <PaymentsDetailsDialog
        open={openDetails}
        onClose={handleCloseDetails}
        detailsData={detailsData}
        dialogInfo={dialogInfo}
      />
    </Box>
  );
};

export default ViewPaymentsTable;
